import React from "react";
import "../../css_files/Master/SearchMaster.css";

function SearchMaster({ text, setshowaddform, setshowsearchform }) {
  return (
    <button
      className="search-master"
      onClick={() => {
        setshowsearchform(true);
        setshowaddform(false);
      }}
    >
      <p>{text}</p>
      <i className="fa-solid fa-search" title={text}></i>
    </button>
  );
}

export default SearchMaster;
